<template>
  <div class="all-wrapper menu-side with-pattern">
   <div class="auth-box-w wider">
     <div class="logo-w"><img alt="" src="../../assets/img/onetap_transparent.png" height="90"></div>
      <h4 class="auth-header">Account Verification</h4>
      <form @submit="verify">
        <p>Please check your email for the verification code.</p>
        <div class="alert alert-danger" role="alert" v-if="errors.length" v-for="error in errors">
          {{ error }}
        </div>
         <div class="form-group">
            <label for=""> Code</label><input class="form-control" placeholder="Enter verification code" type="verification_code" v-model="verification_code">
            <div class="pre-icon os-icon os-icon-fingerprint"></div>
         </div>
         <div class="buttons-w"><button class="btn btn-primary">Verify</button></div>
      </form>
   </div>
 </div>
</template>

<script>
export default {
  name: 'Verification',
  metaInfo: {
    title: 'Verification',
    titleTemplate: 'onetap | %s',
    meta: [
      { property: 'og:title', content: 'onetap | Register' },
      { property: 'og:site_name', content: 'onetap' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://onetap.gg/'},
      { property: 'og:description', content: 'Providing public & private CS:GO servers' },
      { itemprop: 'name', content: 'onetap | Register' },
      { itemprop: 'description', content: 'Providing public & private CS:GO servers'},
    ]
  },
  data() {
    return {
      registerBg: [
        require('../../assets/img/de_dust2.jpg'),
      ],
      image: null,
      errors: [],
      verification_code: null
    }
  },
  methods: {
    verify: function(e) {
      e.preventDefault();
      this.errors = [];

      if (!this.verification_code) {
        this.errors.push('Verification code is required!');
        return;
      }

      this.errors.push('Verifying, please wait.');

      this.axios.post(`${this.API_URL}/auth/verify`, { ticket: this.$root.authTicket, verification_code: parseInt(this.verification_code) }).then((res) => {
        this.$root.authToken = res.data.token;
        this.$root.authTicket = null;
        this.$root.getKraken();
        setTimeout(() => {
          this.connectSteam();
        }, 500)
      }).catch((err) => {
        this.errors = [];
        this.errors.push(err.response.data.message);
      });
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    connectSteam() {
      this.axios.get(`${this.API_URL}/auth/@me/steam`, { headers: { 'Authorization': this.$root.authToken } }).then((res) => {
        window.location.href = res.data.url;
      });
    },
  },
  mounted() {
    //
  },
  created() {
    if (this.$root.isAuthenticated) {
      this.$router.push('/');
    }
    let random = Math.floor(Math.random() * this.registerBg.length);
    this.image = this.registerBg[random];
    window.$('body').removeClass('before-body menu-position-side menu-side-left full-screen with-content-panel');
    window.$('body').css('background-image', 'url("' + this.image + '")');
    window.$('body').css('background-size', 'cover');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
